import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
  root: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#F4F6F8",
    fontFamily: "'Lato', 'Segoe UI', sans-serif",
  },
  content: {
    width: "100%",
    maxWidth: 640,
    margin: "0 auto",
    paddingTop: theme.spacing(13),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(5),
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(3),
  },
  manualActions: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    gap: theme.spacing(1.5),
  },
  rejectButton: {
    flex: 1,
    minHeight: 48,
    borderRadius: 12,
    backgroundColor: "#FEECEC",
    border: "1px solid #E5484D",
    color: "#B42318",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "rgba(231, 0, 11, 0.14)",
      boxShadow: "none",
    },
  },
  allowButton: {
    flex: 1,
    minHeight: 48,
    borderRadius: 12,
    backgroundColor: "#E9FBF0",
    border: "1px solid #2BE65E",
    color: "#0B7A3B",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "rgba(38, 173, 43, 0.18)",
      boxShadow: "none",
    },
  },
  allowLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
  },
  allowIcon: {
    fontSize: 20,
  },
  actionError: {
    width: "100%",
    color: "#B42318",
    fontSize: "0.9rem",
    textAlign: "center",
  },
  scanButton: {
    width: "100%",
    minHeight: 52,
    fontSize: "1.05rem",
    borderRadius: 14,
    backgroundColor: "#003350",
    color: "#FFFFFF",
    "&:hover": { backgroundColor: "#002635" },
    "& .MuiButton-label": {
      display: "inline-flex",
      alignItems: "center",
      gap: theme.spacing(1),
    },
  },
  scanIcon: {
    fontSize: 22,
  },
  autoBack: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: "#5B5D66",
    fontSize: "0.8rem",
  },
  autoBackTrack: {
    height: 6,
    flex: 1,
    overflow: "hidden",
    borderRadius: 999,
    backgroundColor: "#D9DDE2",
  },
  autoBackProgress: {
    display: "block",
    height: "100%",
    borderRadius: "inherit",
    background: "linear-gradient(90deg, #0ADBDB 0%, #2BE65E 100%)",
    transition: "width 1s linear",
  },
  })
);

export default useStyles;
